import { Button } from "@design";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { BuildEntity } from "./examplePrompts";
import { useEditWithAi } from "./useEditWithAi";

/** A detail page's "Edit with AI" (only for people who can edit the entity). */
export function EditWithAiButton({ entityType, uuid }: Readonly<{ entityType: BuildEntity; uuid: string }>) {
  const { t } = useTranslation("build", { keyPrefix: "editWithAi" });
  const edit = useEditWithAi(entityType, uuid);
  return (
    <Button variant="secondary" size="sm" leadingIcon={<Sparkles size={14} />} loading={edit.busy} onClick={edit.open}>
      {t("action")}
    </Button>
  );
}
